// These hooks cannot yet be implemented
// We need to implment the necessary features first

import { channel } from "@/lib/Types/Channel";
import { PlatformDataEvents } from "@/lib/PlatformData/PlatformDataEvents";
import { usePlatformDataTracking } from "@/lib/PlatformData/platformDataStore";

export interface UserEventInteractionParams {
  label: string;
  action: string;
  category: string;
  interactiveHit: number;
}

export const userEventInteraction = ({
  label,
  action,
  category,
  interactiveHit,
}: UserEventInteractionParams) => {
  return {
    event: PlatformDataEvents.USER_INTERACTION,
    user: {
      interaction: {
        action: action,
        category: category,
        label: label,
        n: interactiveHit,
      },
    },
  };
};

// TODO: To be used in hotel detail page
export const useMiniAsnToggled = () => {
  const { pushEvent } = usePlatformDataTracking();

  return (isOpen: boolean) => {
    const miniAsnToggleState = userEventInteraction({
      label: isOpen ? "open" : "close",
      action: "search_and_filter",
      category: "filters",
      interactiveHit: 0,
    });
    pushEvent(miniAsnToggleState);
  };
};

export const useTrackChannelChange = () => {
  const { pushEvent } = usePlatformDataTracking();

  return (viewMode: { channel: channel }) => {
    const label =
      viewMode.channel === channel.HOTEL ? "change-hotel" : "change-package";
    const channelChangeData = userEventInteraction({
      label: label,
      action: "product_category",
      category: "search_refiner",
      interactiveHit: 0,
    });
    pushEvent(channelChangeData);
  };
};

// TODO: Ask platform data team if this is needed
export const useUserChangeSearchFormAction = () => {
  const { pushEvent } = usePlatformDataTracking();

  return (payload: { newVal: string; action: string; category: string }) => {
    const { newVal, action, category } = payload;

    const trackerData = userEventInteraction({
      label: newVal,
      action: action,
      category: category,
      interactiveHit: 0,
    });
    pushEvent(trackerData);
  };
};
